import DashboardPreview from "./DashboardPreview";
import Reveal from "./Reveal";
import "./landing.css";
import { BRAND, TEXT } from "../dashboard-v2/shared/styles";

// --- InfoSection ---
export default function InfoSection({ onRegisterClick }) {
  return (
    <div
      className="sdx"
      style={{ padding: "4rem 2rem", maxWidth: "1200px", margin: "0 auto" }}
    >
      {/* Abschnitt 1: Lieferkette */}
      <Reveal>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginBottom: "3rem",
            gap: "2rem",
          }}
        >
          <img className="lp-figure" src="/images/Lieferkette.png" alt="Datenerfassung" />
          <div
            style={{
              flex: "1 1 300px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <h2 className="h2 lp-accent lp-accent-start" style={{ marginBottom: "1rem", color: BRAND }}>
              Ihre Versicherer und Flottenkunden fragen <br /> zunehmend nach CO2-Nachweisen.
            </h2>
            <p className="p" style={{ color: TEXT }}>
              Mit GreenOne liefern Sie diese auf Knopfdruck, statt sie mühsam von Hand zusammenzustellen.
              Ein sauberer Nachweis heute erspart Ihnen Aufwand und offene Fragen morgen.
            </p>
          </div>
        </div>
      </Reveal>

      {/* Abschnitt 2: Massnahmen */}
      <Reveal>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginBottom: "3rem",
            gap: "2rem",
            flexDirection: "row-reverse",
          }}
        >
          <img className="lp-figure" src="/images/Massnahmen.png" alt="Massnahmen" />
          <div
            style={{
              flex: "1 1 300px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <h2 className="h2 lp-accent lp-accent-start" style={{ marginBottom: "1rem", color: BRAND }}>
              Erreichen Sie Ihre Emissions- und Kostenziele <br /> mit
              individuellen Massnahmenempfehlungen.
            </h2>
            <p className="p" style={{ color: TEXT }}>
              GreenOne analysiert Ihre Betriebs- und Emissionsdaten und
              vergleicht sie mit der Branche. Daraus entstehen konkrete,
              nach CO₂-Wirkung und Kosten priorisierte Massnahmen, damit Sie
              Ihre Reduktionsziele schneller und effizienter erreichen.
            </p>
          </div>
        </div>
      </Reveal>

      {/* Abschnitt 3: ESG-Boxen */}
      <Reveal>
        <h2
          className="h2 lp-accent"
          style={{ textAlign: "center", marginBottom: "2rem", color: BRAND }}
        >
          So sparen Sie mit GreenOne:
        </h2>
      </Reveal>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "stretch", // <– alle Boxen gleich hoch
          gap: "1rem",
          marginBottom: "3rem",
        }}
      >
        <Reveal delay={0} flexItemStyle={{ flex: "1 1 320px", maxWidth: 400 }}>
          <div className="lp-card">
            <h3 className="h3" style={{ color: BRAND }}>
              Sparpotenziale erkennen
            </h3>
            <p className="p" style={{ color: TEXT }}>
              Erfassen Sie Ihre Emissionen und sehen im Branchenvergleich sofort, wo Ihr Betrieb mehr verbraucht und Geld liegen lässt.
            </p>
          </div>
        </Reveal>

        <Reveal delay={120} flexItemStyle={{ flex: "1 1 320px", maxWidth: 400 }}>
          <div className="lp-card">
            <h3 className="h3" style={{ color: BRAND }}>

              Massnahmen mit Spareffekt
            </h3>
            <p className="p" style={{ color: TEXT }}>
              Erhalten Sie konkrete Massnahmen, priorisiert nach Kosten und Wirkung. Inklusive Förder-Hinweisen, damit sich jede Investition schneller amortisiert. 
            </p>
          </div>
        </Reveal>

        <Reveal delay={240} flexItemStyle={{ flex: "1 1 320px", maxWidth: 400 }}>
          <div className="lp-card">
            <h3 className="h3" style={{ color: BRAND }}>
              Nachweise ohne Aufwand
            </h3>
            <p className="p" style={{ color: TEXT }}>
              Exportieren Sie CO2-Nachweise mit einem Klick, auch für Versicherer- und Flotten-Anforderungen. Kein manuelles Zusammensuchen mehr.

            </p>
          </div>
        </Reveal>
      </div>


      {/* Abschnitt 4: Vertrauen */}
      <Reveal>
        <h2
          className="h2 lp-accent"
          style={{ textAlign: "center", marginBottom: "2rem", color: BRAND }}
        >
          Warum GreenOne vertrauen?
        </h2>
      </Reveal>

      <DashboardPreview onRegisterClick={onRegisterClick} />
    </div>
  );
}

